import { render, staticRenderFns } from "./UpdateBranchSwap.vue?vue&type=template&id=f61c9c34&scoped=true"
import script from "./UpdateBranchSwap.vue?vue&type=script&lang=js"
export * from "./UpdateBranchSwap.vue?vue&type=script&lang=js"
import style0 from "./UpdateBranchSwap.vue?vue&type=style&index=0&id=f61c9c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61c9c34",
  null
  
)

export default component.exports